import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const CustomHublIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CustomHubl",
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.95 29.99h-.27c-1.35 0-2.54-.69-3.24-1.73-1.22-2.12-.61-3.74 0-5.3q.195-.51.39-1.08c.13-.39.2-.85.2-1.32 0-.89-.26-1.73-.71-2.43v.02a3.1 3.1 0 0 0-2.46-1.21c-.09 0-.17 0-.26.01h.01c-.54 0-.97-.44-.97-.97s.44-.97.97-.97h.24c1 0 1.89-.47 2.46-1.2.44-.69.7-1.52.7-2.42q0-.705-.21-1.35v.03c-.12-.38-.25-.74-.38-1.08-.59-1.57-1.19-3.19.02-5.29 1.21-2.11 4.3-1.87 5.89-1.33.39.13.66.5.66.92 0 .11-.02.22-.05.32a.984.984 0 0 1-1.24.61s-2.8-.87-3.57.47-.43 2.17.12 3.61q.21.555.42 1.17c.18.57.29 1.23.29 1.92 0 1.33-.4 2.56-1.08 3.59v-.02c-.28.4-.63.74-1.02 1.02h-.01c.39.3.73.64 1.01 1.03a6.5 6.5 0 0 1 1.07 3.58c0 .68-.11 1.34-.3 1.96v-.05c-.12.41-.27.8-.41 1.17-.54 1.44-.88 2.31-.12 3.61s3.57.49 3.59.49c.12-.06.27-.1.42-.1a.97.97 0 0 1 .21 1.92c-.71.25-1.52.4-2.36.41Zm10.37 0c-.09 0-.2.01-.3.01-1.34 0-2.52-.69-3.21-1.74-1.22-2.12-.61-3.74 0-5.29.13-.34.26-.7.39-1.09s.2-.85.2-1.32c0-.89-.26-1.73-.71-2.43v.02a3.1 3.1 0 0 0-2.46-1.22c-.09 0-.18 0-.27.01h.01c-.54 0-.97-.44-.97-.97s.44-.97.97-.97h.23c1 0 1.89-.47 2.46-1.21.44-.69.7-1.52.7-2.42q0-.705-.21-1.35v.03c-.12-.38-.25-.74-.38-1.09-.59-1.56-1.2-3.18 0-5.28 1.2-2.11 4.32-1.87 5.93-1.32.39.13.66.5.66.92 0 .11-.02.22-.05.32a.984.984 0 0 1-1.24.61s-2.8-.88-3.59.49c-.8 1.37-.43 2.18.12 3.61q.21.555.42 1.17c.18.57.29 1.23.29 1.92 0 1.33-.4 2.56-1.08 3.59v-.02c-.28.39-.62.72-1 1h-.01c.39.3.73.64 1.01 1.03a6.5 6.5 0 0 1 1.07 3.58c0 .68-.11 1.34-.3 1.96v-.05c-.12.42-.27.8-.41 1.17-.54 1.44-.87 2.31-.12 3.61.76 1.3 3.57.49 3.59.49a.8.8 0 0 1 .22-.03c.54 0 .97.44.97.97 0 .39-.23.72-.55.88-.71.25-1.53.4-2.38.41"
    })
  }));
};